var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"org-object-actions-menu"},[_c(_setup.MenuIcon,{attrs:{"dropdownItems":_setup.visibleMenuItems,"isOpen":_setup.isMenuOpen,"menuWidth":true},on:{"onClick":_setup.handleMenuClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }